import script from "./recipe-list.vue?vue&type=script&setup=true&lang=js"
export * from "./recipe-list.vue?vue&type=script&setup=true&lang=js"

import "./recipe-list.vue?vue&type=style&index=0&id=36a9eb94&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36a9eb94"]])

export default __exports__